// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Box, Heading, Text, Button, Flex } from 'theme-ui'
import strings from '../../../strings/strings'
import PolisNet from '../../../util/net'

const UTMStats = ({ conversation_id }) => {
  const [rows, setRows] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!conversation_id) return
    PolisNet.polisGet('/api/v3/utm/stats', { conversation_id })
      .then((data) => setRows(data.rows || []))
      .catch(() => setError('Could not load UTM stats'))
  }, [conversation_id])

  const handleExport = async () => {
    try {
      await PolisNet.downloadCsv(
        '/api/v3/utm/export',
        { conversation_id },
        `utm_${conversation_id}.csv`
      )
    } catch (e) {
      console.error('UTM export error', e)
    }
  }

  if (error) return null
  if (!rows) return null
  if (rows.length === 0) return null

  return (
    <Box sx={{ mt: [4] }}>
      <Flex sx={{ alignItems: 'center', justifyContent: 'space-between', mb: [2] }}>
        <Heading as="h4" sx={{ fontSize: [2], fontWeight: 600 }}>
          {strings('mon_utm_sources')}
        </Heading>
        <Button
          variant="outline"
          sx={{ fontSize: [1], px: [2], py: [1], cursor: 'pointer' }}
          onClick={handleExport}
        >
          ↓ {strings('mon_download_csv')}
        </Button>
      </Flex>

      <Box
        as="table"
        sx={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: [1],
        }}
      >
        <thead>
          <Box
            as="tr"
            sx={{ borderBottom: '2px solid', borderColor: 'muted', textAlign: 'left' }}
          >
            <Box as="th" sx={{ pb: [1], pr: [3] }}>{strings('mon_source')}</Box>
            <Box as="th" sx={{ pb: [1], pr: [3] }}>{strings('mon_medium')}</Box>
            <Box as="th" sx={{ pb: [1], pr: [3] }}>{strings('mon_campaign')}</Box>
            <Box as="th" sx={{ pb: [1], textAlign: 'right' }}>{strings('mon_participants')}</Box>
          </Box>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <Box
              as="tr"
              key={i}
              sx={{ borderBottom: '1px solid', borderColor: 'muted' }}
            >
              <Box as="td" sx={{ py: [1], pr: [3] }}>
                <Text sx={{ fontWeight: row.utm_source === '(direct)' ? 400 : 600 }}>
                  {row.utm_source}
                </Text>
              </Box>
              <Box as="td" sx={{ py: [1], pr: [3] }}>
                <Text sx={{ color: row.utm_medium ? 'text' : 'muted' }}>
                  {row.utm_medium || '—'}
                </Text>
              </Box>
              <Box as="td" sx={{ py: [1], pr: [3] }}>
                <Text sx={{ color: row.utm_campaign ? 'text' : 'muted' }}>
                  {row.utm_campaign || '—'}
                </Text>
              </Box>
              <Box as="td" sx={{ py: [1], textAlign: 'right' }}>
                <Text sx={{ fontWeight: 700 }}>{row.participants}</Text>
              </Box>
            </Box>
          ))}
        </tbody>
      </Box>
    </Box>
  )
}

UTMStats.propTypes = {
  conversation_id: PropTypes.string
}

export default UTMStats
